<template>
  <nav
    class="navigation"
    :class="{
      'mobile': isMobile,
      'dark-theme': isLoginPage ||
        $route.path.includes('change_password') ||
        $route.path.includes('visit_cancellation') ||
        $route.path.includes('user_activation'),
      'hide': hideNav,
    }"
  >
    <div
      class="trademark-wrapper"
      @click="$router.push({ path: '/' })"
    >
      <img
        class="trademark"
        src="../assets/logo-vw.png"
        alt="#"
      >
    </div>
    <template v-if="loginStatus.loggedIn && !$route.path.includes('visit_cancellation')">
      <div class="menu-controls">
        <div
          @click="toggleNav"
          class="burger-menu"
          :class="{ 'open': showNav }"
        >
          <span />
          <span />
          <span />
        </div>
        <ul
          class="navigation-list"
          :class="{ 'open': showNav }"
        >
          <li
            class="navigation-element"
            v-for="(elem, index) in navigation"
            :class="{ 'active': checkActiveRoute(elem.to) }"
            :key="index"
          >
            <router-link
              class="navigation-element-link"
              :to="elem.to"
              @click.native="toggleNav"
            >
              {{ elem.name }}
            </router-link>
          </li>
          <li class="vgp-link">
            <a href="https://www.volkswagen.pl/">
              Przejdź do <span>volkswagen.pl</span>
            </a>
          </li>
          <div class="spacer" />
          <div class="user-controls">
            <div class="user-info">
              {{ isMobile ? '' : 'Zalogowany jako:' }}
              <span class="bold">
                {{ `${userInfo.firstName} ${userInfo.lastName}` }}
              </span>
            </div>
            <div class="user-buttons">
              <div
                class="user-button-wrapper"
                @click="goToUserProfile">
                <button
                  class="icon-button"
                >
                  <svg class="user-icon" svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M20.1 15.5a4.94 4.94 0 0 0 5.3-5.3c0-3.3-1.4-5.9-5.3-5.9s-5.3 2.7-5.3 5.9 2.1 5.3 5.3 5.3zm11 13.2c-.1-8.4-1.8-11.5-7.5-12.4a5.62 5.62 0 0 1-3.5 1.1 5.42 5.42 0 0 1-3.5-1.1c-6 .7-7.8 3.8-7.9 12.2v5.1a.71.71 0 0 0 .7.8s2.4 1.1 10.6 1.1 10.5-1.1 10.5-1.1a.77.77 0 0 0 .7-.8s-.1-4.6-.1-4.9z" fill="#111"/></svg>
                  <p>
                    Mój profil
                  </p>
                </button>
              </div>
              <div
                class="user-button-wrapper"
                @click="goToUserProfile">
                <button
                  class="icon-button"
                  @click="onLogout()"
                >
                  <svg class="logout-icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="st0" d="M15.5 5.3v2.9c1.4 1.1 2.2 2.7 2.2 4.6 0 3.2-2.6 5.7-5.7 5.7s-5.7-2.6-5.7-5.7c0-1.9.9-3.6 2.4-4.6v-3c-2.9 1.3-5 4.2-5 7.6 0 4.6 3.7 8.2 8.2 8.2s8.2-3.7 8.2-8.2c.1-3.4-1.8-6.3-4.6-7.5z"/><path class="st0" d="M12 13.7c.7 0 1.3-.6 1.3-1.3V4.3c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3v8.1c0 .7.6 1.3 1.3 1.3z"/></svg>
                  <p>
                    Wyloguj
                  </p>
                </button>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div
        v-show="isMobile && showNav"
        @click.self="toggleNav"
        class="nav-mobile-overlay"
      />
    </template>
    <div
      class="vgp-link"
      v-else
    >
      <a
        href="https://www.volkswagen.pl/">
        Przejdź do <span>volkswagen.pl</span>
      </a>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    hideNav: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      thirdColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      userInfo: 'user/getUserInfo',
      loginStatus: 'auth/getAuthStatus',
      fonts: 'brand/getFonts',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    isLoginPage() {
      return this.$route.name.includes('LoginPage');
    },
  },
  data() {
    return {
      showNav: false,
      navigation: [
        {
          name: 'Moje samochody',
          to: '/dashboard/mycars',
        },
        {
          name: 'Wizyty serwisowe',
          to: '/dashboard/visits/next/all',
        },
        {
          name: 'Znajdź Partnera Serwisowego',
          to: '/dashboard/map',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    checkActiveRoute(path) {
      return path === this.$route.path;
    },
    onLogout() {
      this.toggleNav();
      this.logout();
    },
    goToUserProfile() {
      this.$router.push({ path: '/dashboard/profile' });
      if (this.isMobile) {
        this.toggleNav();
      }
    },
    toggleNav() {
      this.showNav = !this.showNav;
    },
  },
  watch: {
    hideNav() {
      if (this.hideNav) {
        this.showNav = false;
      }
    },
  },
};
</script>
